import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/website/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Simple";
const frontMatter = {};
import HelloWorld from '@/examples/hello-world';
import Simple from '@/examples/simple';
export function useTOC(props) {
  return [{
    value: "Hello World",
    id: "hello-world",
    depth: 2
  }, {
    value: "Counter",
    id: "counter",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    h2: "h2",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<HelloWorld />{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<Simple /></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/examples/simple',
  {"filePath":"src/pages/examples/simple.mdx","timestamp":1758550271000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)